import { dateFormat } from '@app/constants'

import { getFullNameFromUser, mapRoleToPosition } from '@app/utils'

import { getFormattedDate } from '../date'

import type { InternalTaskItemDto } from '@app/api/routes/internalTasks/dtos'
import type { InternalTasksItemDataSource } from '@app/types/dataSource'

export const getInternalTasksItemDataFromResponse = (
  response?: InternalTaskItemDto
): InternalTasksItemDataSource | undefined => {
  if (!response) return

  const rawData: InternalTaskItemDto | undefined = response

  if (!rawData) return

  return {
    name: rawData.name,
    status: rawData.status,
    createdAt: rawData.createdAt,
    initiator: getFullNameFromUser(rawData.initiator),
    role: mapRoleToPosition(rawData.role) ?? '',
    deadline: getFormattedDate(rawData.deadline, dateFormat.DD_MM_YYYY),
    executor: rawData.executor,
    monitoringId: rawData.monitoringList.id,
    toDeleteCount: rawData.toDeleteCount,
    toAddCount: rawData.toAddCount,
    toChangeCount: rawData.toChangeCount
  }
}
